<template>
  <div class="bound">
    <div class="share-main">
      <img
        src="../../assets/img/dianpu/icon-close@2x.png"
        class="close"
        @click="closeShare"
        alt=""
      />
      <img src="../../assets/images/jpg-dianpu@2x.png" class="bg" alt="" />
      <!-- <div class="share-money">{{profit}}元</div> -->
      <div class="share-btn-hint">
        <div class="btn" @click="toSharePoster">分享</div>
        <div class="hint">详细收益情况在“我的-我的推广”中查看</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shopId:0,
      shopName:'',
      productName: '',
      productImg:''
    };
  },
  methods: {
    closeShare() {
      this.$emit("closeShare");
    },
    toSharePoster() {
      this.$router.push({
        path:"/shareShop",
        query:{
          shopId:this.shopId,
          productId:this.productId,
          productName:this.productName,
          productImg:this.productImg,
          shopName:this.shopName
        }
      });
    },
  },
  created() {
    console.log("==== ",this.$parent)
    this.shopId = this.$parent.shopId;
    this.productId = this.$parent.productId;
    if(this.$parent.shopMsg !== undefined){
      this.shopName = this.$parent.shopMsg.shopName;
      this.productImg = this.$parent.shopMsg.logo;
    }else if (this.$parent.courseDeatil !== undefined){
      this.shopName = this.$parent.courseDeatil.shopName;
      this.productName = this.$parent.courseDeatil.title;
      this.productImg = this.$parent.courseDeatil.thumbnail;
    }

  }
};
</script>

<style lang="scss" scoped>
.bound {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.7);
  .share-main {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 18rem;
    transform: translate(-50%, -50%);
    border-radius: 9px;
    .close {
      position: absolute;
      top: -17px;
      right: 0px;
      width: 27px;
      height: 27px;
    }
    .bg {
      width: 100%;
      vertical-align: middle;
    }
    .share-money {
      position: absolute;
      top: 18%;
      left: 50%;
      transform: translateX(-50%);
      font-size: 32px;
      color: #ff3d15;
    }
    .share-btn-hint {
      position: absolute;
      bottom: 6%;
      left: 50%;
      transform: translateX(-50%);
      .btn {
        width: 200px;
        height: 40px;
        background: #ff6060;
        border-radius: 20px;
        margin: 24px auto 0;
        color: #fff;
        line-height: 40px;
      }
      .hint {
        margin-top: 8px;
        color: #6a6a6a;
        font-size: 12px;
        white-space: nowrap;
      }
      .btn,
      .hint {
        text-align: center;
      }
    }
  }
}
</style>
